import Utils from '@/core/utils/Utils';
import SWBudgetItemsDAO from '@/domains/SWBudgetItems/SWBudgetItemsDAO';
import SWBudgetItem from '@/domains/SWBudgetItems/SWBudgetItem';
import SWPaymentDestination from '@/domains/SWPaymentDestinations/SWPaymentDestination';

/**
 * Сервис статей бюджета
 */
class SWBudgetItemsService {

    /**
     * Загружает список статей бюджета по назначению платежа
     */
    static async getList(
      filters: {
        swPaymentDestination: SWPaymentDestination
      }
    ): Promise<SWBudgetItem[]> {
        const response = await SWBudgetItemsDAO.getList(filters);
        return Utils.hydrateArray(response.data, SWBudgetItem.fromServer);
    }
}

export default SWBudgetItemsService;
